class Fn {
  constructor() {}

  static fixedBody() {
    const isStop = document.body.classList.toggle('is-stop');
  }
}

export default Fn;
